export default "__VITE_ASSET__DH5Op6R1__"